import axios, { type AxiosResponse } from "axios";

export default class Widget
{
    #wrapperElement: HTMLDivElement;

    constructor()
    {
        this.#wrapperElement = document.querySelector(".sitesmart-calendar-wrapper") as HTMLDivElement;
        this.render();
        this.initEventListeners();
    }

    render()
    {
        const calendarWidth = this.#wrapperElement?.getBoundingClientRect().width;

        const obj: NodeListOf<HTMLDivElement> = document.querySelectorAll('body .sitesmart-calendar-day-wrapper:not(.week-no)');
        const allDays: NodeListOf<HTMLDivElement> = this.#wrapperElement.querySelectorAll('.sitesmart-calendar-day-header, .sitesmart-calendar-day-wrapper');
        const weekNo: NodeListOf<HTMLDivElement> = document.querySelectorAll('body .sitesmart-calendar-day-wrapper.week-no');

        const height = obj?.[0]?.getBoundingClientRect?.().width * 0.75;

        for (const o of obj) {
            o.style.height = `${height}px`;
        }

        for (const wn of weekNo) {
            wn.style.height = `${height}px`;
        }

        if (calendarWidth < 300) {

            for (const day of allDays) {
                day.style.padding = "0px";
                const dayP = day.querySelector("p");
                if (dayP) {
                    dayP.style.padding = "0px";
                    dayP.style.margin = "0px";
                    dayP.style.textAlign = "center";
                }
            }

            const weekNos: NodeListOf<HTMLDivElement> = this.#wrapperElement.querySelectorAll(".week-no");
            const header: NodeListOf<HTMLDivElement> = this.#wrapperElement.querySelectorAll(".sitesmart-calendar-day-header");

            for (const wn of weekNos) {
                wn.style.display = "none";
            }

            if (header?.[0]) {
                header[0].style.display = "none";
            }

            for (const h of header) {
                h.style.height = "auto";
                h.style.paddingBottom = "10px";
            }
        }
    }

    initEventListeners()
    {
        const calendarMonthLinkElements: NodeListOf<HTMLAnchorElement> = document.querySelectorAll(".sitesmart-calendar-month-link");

        for (const a of calendarMonthLinkElements) {
            a.addEventListener("click", (e: MouseEvent) => {

                e.preventDefault();

                if (!e?.currentTarget) {
                    return false;
                }

                const target = e.currentTarget as Element;
                const wrapper = this.findParent(target as Element, ".sitesmart-calendar-wrapper")?.[0];
                const calendarWrapperId = wrapper.getAttribute('id');
                const objectId = calendarWrapperId?.replace?.('sitesmart-calendar-wrapper-', '');
                const date = target.getAttribute('data-sitesmart-calendar-date');

                const calendarObjectUrl = window._siteConfig.SITESMART_SITE_URL
                    + '@/Calendar/?action=getContent'
                    + '&objectId=' + objectId
                    + '&date=' + date;

                console.log(calendarObjectUrl);
                axios.get(calendarObjectUrl).then((r: AxiosResponse) => {
                    const content = r?.data ?? "";
                    this.#wrapperElement.innerHTML = content;
                    this.render();
                    this.initEventListeners();
                });

            });
        }
    }

    findParent(element: Element | null, selector?: string): Element[]
    {
        const parents: Element[] = [];
        let current = element?.parentElement;

        while (current) {
            if (!selector || current.matches(selector)) {
                parents.push(current);
            }
            current = current.parentElement;
        }

        return parents;
    }
}
